// extracted by mini-css-extract-plugin
module.exports = {"main":"Burger_main__2d261","burger-bar":"Burger_burger-bar__NAnuy","clicked":"Burger_clicked__6H2Dw","unclicked":"Burger_unclicked__8wEeJ"};